import Scheduling from "utils/Scheduling";
import { PRINT_QUEUE_MAX_ITEMS } from "utils/printViewSections";
import {
  enumerateDateKeysInRange as enumerateLocalDateKeysInRange,
  getDateKeyFromInput,
  isDateKeyInRange,
  parseDateKeyToLocalDate,
} from "utils/dateTime";

const DATE_STRING_ORDINAL_RE = /^(.+?\s+\d+)(st|nd|rd|th)(,\s*\d{4})$/;

export const formatDateStringForDisplay = (dateString) => {
  const spaceIndex = dateString.indexOf(" ");
  if (spaceIndex === -1) return dateString;

  const month = dateString.slice(0, spaceIndex);
  if (month.length <= 4) return dateString;

  return `${month.slice(0, 3)}.${dateString.slice(spaceIndex)}`;
};

export const splitDateStringOrdinal = (dateString) => {
  const match = String(dateString || "").match(DATE_STRING_ORDINAL_RE);
  if (!match) {
    return { before: dateString, ordinal: null, after: "" };
  }

  return { before: match[1], ordinal: match[2], after: match[3] };
};

export const buildPrintViewDateData = (dateObject) => {
  const dayIndex = dateObject.getDay();
  const dayName = Scheduling.daysLong[dayIndex];
  const databaseFormattedDate = getDateKeyFromInput(dateObject);
  return {
    dayName,
    dayNamePlural: `${dayName}s`,
    dateString: `${Scheduling.monthsLong[dateObject.getMonth()]} ${dateObject.getDate()}${Scheduling.suffix[dateObject.getDate()]}, ${dateObject.getFullYear()}`,
    year: dateObject.getFullYear(),
    month: dateObject.getMonth(),
    day: dateObject.getDate(),
    databaseFormattedDate,
  };
};

export const buildPrintViewDateDataFromKey = (dateKey) => {
  const localDate = parseDateKeyToLocalDate(dateKey);
  if (!localDate) {
    return buildPrintViewDateData(new Date());
  }
  return buildPrintViewDateData(localDate);
};

export const isItemActiveOnDate = (item, dateData, useActiveDates) => {
  if (!useActiveDates) {
    return item?.active !== false;
  }

  if (item?.startDate === undefined) {
    return true;
  }

  if (Array.isArray(item.startDate)) {
    if (item.startDate.length > 0) {
      const dayNamePlural = dateData?.dayNamePlural || (dateData?.dayName ? `${dateData.dayName}s` : "");
      return item.startDate.includes(dayNamePlural);
    }
    return true;
  }

  return isDateKeyInRange(dateData, item.startDate, item.endDate || item.startDate);
};

export const filterContentBoxesForPrintView = (boxes = [], dateData, useActiveDates) => {
  if (!useActiveDates) {
    return [...boxes];
  }
  return boxes.filter((box) => isItemActiveOnDate(box, dateData, useActiveDates));
};

export const filterAnnouncementsForPrintView = (announcements = [], classId, dateData, useActiveDates) => {
  const forClass = announcements.filter((announcement) => announcement.classIds?.includes(classId));
  if (!useActiveDates) {
    return forClass.filter((announcement) => announcement.active === true);
  }
  return forClass.filter((announcement) => isItemActiveOnDate(announcement, dateData, useActiveDates));
};

export const enumerateDateKeysInRange = (startKey, endKey, maxDays = PRINT_QUEUE_MAX_ITEMS) => {
  return enumerateLocalDateKeysInRange(startKey, endKey, maxDays);
};
